export default __webpack_public_path__ + "60d9f0635eb3772a59cea59ebdb18f79.woff";